export enum StreamStability {
  Stable = 'stable',
  Unstable = 'unstable',
}

export type CameraInspectionData = {
  kind: string;
  label: string;
  facingMode: string | undefined;
  frameRate: number | undefined;
  aspectRatio: number | undefined;
  width: number | undefined;
  height: number | undefined;
  streamStability: StreamStability | undefined;
  allCameraLabels?: string[];
  selectedCameraIndex?: number;
};
